export default {
  namespaced: true,
  state: {
    audio: null,
    video: null,
  },
  getters: {
    // getters
  },
  mutations: {
    setAudio(state, audio) {
      state.audio = audio;
    },
    setVideo(state, video) {
      state.video = video;
    },
    clearVideo(state) {
      state.video = null;
    },
    clearAudio(state) {
      state.audio = null;
    },
  },
  actions: {
    sendAudio({ state }, { fullname, phone }) {
      return this.$axios.post('/feedback/audio', {
        feedback: {
          name: fullname,
          phone_number: phone,
          audio_file_link: state.audio?.fullpath,
        },
      }).then(({ data }) => data);
    },
    sendVideo({ state }, { fullname, phone }) {
      return this.$axios.post('/feedback/video', {
        feedback: {
          name: fullname,
          phone_number: phone,
          video_file_link: state.video?.fullpath,
        },
      }).then(({ data }) => data);
    },
    clearAll({ commit }) {
      commit('clearVideo');
      commit('clearAudio');
    },
  },
};
